import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './core/errors/pagenotfound/pagenotfound.component';
import { MpApiErrorInterceptor } from './core/interceptors/mp-api-error/mp-api-error.interceptor';
import { MpApiInterceptor } from './core/interceptors/mp-api/mp-api.interceptor';
import { PipeModule } from './core/pipes/pipe.module';
import { MpLoadingButtonModule } from './widgets/mp-loading-button/mp-loading-button.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MPDateAdapter } from './core/adapter/date/mp-date.adapter';
import { MpApiErrorMessageModule } from './widgets/mp-api-error-message/mp-api-error-message.module';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    PipeModule,
    MpApiErrorMessageModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    NgxStripeModule.forRoot(environment.stripe.publicApiKey),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      defaultLanguage: 'fr'
    }),
    MpLoadingButtonModule
  ],
  providers: [
    provideHttpClient(
        withInterceptors([
          MpApiInterceptor,
          MpApiErrorInterceptor
        ])
    ),
    { provide: DateAdapter, useClass: MPDateAdapter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('fr');
  }
}
